<template>
  <div v-if="user && haveShift">
    <EmployeeShiftDetail v-if="user.role == 'employee' " :user="user" :shift="viewedShift"/>
    <ClientShiftDetail v-if="user.role == 'client' && shiftInUserTeams" :user="user" :shift="viewedShift"/>
    <ManagerShiftDetail v-if="user.role == 'manager'" :user="user" :shift="viewedShift"/>
    <BohShiftDetail v-if="user.bohOrHigher" :user="user" :shift="viewedShift"/>
  </div>
  <div v-else>
    <v-progress-linear indeterminate></v-progress-linear>
  </div>
</template>

<script>
import EmployeeShiftDetail from '@/components/calendar/shift-detail-employee.vue'
import ClientShiftDetail from '@/components/calendar/shift-detail-client.vue'
import ManagerShiftDetail from '@/components/calendar/shift-detail-manager.vue'
import BohShiftDetail from '@/components/calendar/shift-detail-boh.vue'

import { mapState, mapGetters } from 'vuex'

export default {
  components: {
    EmployeeShiftDetail,
    ClientShiftDetail,
    ManagerShiftDetail,
    BohShiftDetail,
  },
  created () {
    const shiftId = this.$route.params.shiftId

    // Don't re-fetch on every load. This is because if we already have a shift
    // in the store we might be navigating via the tabs on this page - in which
    // case we don't want to keep fetching this shift.
    if (this.viewedShift && this.viewedShift.id === parseInt(shiftId)) {
      this.haveShift = true
      return
    }

    this.apiCallPending = true
    this.$store.dispatch('shifts/getShift', shiftId)
      .then(s => {
        this.haveShift = true
      })
      .catch(e => {
        console.log(e)
        this.haveShift = false
      })
      .finally(r => {
        this.apiCallPending = false
      })
  },
  watch: {
  },
  computed: {
    ...mapState('userAuth', [
      'user',
    ]),
    ...mapState('shifts', [
      'viewedShift',
      'notes',
    ]),
    shiftInUserTeams () {
      return this.user.clientWorksiteIds.includes(this.viewedShift.worksiteId);
    },
  },
  data: function() {
    return {
      haveShift: false,
      apiCallPending: false,
    }
  },
}
</script>

